import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = `${process.env.REACT_APP_BASE_URL}/blog/`;

export const blogApiService = createApi({
    reducerPath: 'blogApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({
        getBlogs: builder.query({
            query: () => 'get',
            // Disable caching
            keepUnusedDataFor: 0,
            // Force refetch on mount or args change
            refetchOnMountOrArgChange: true
        }),
        getBlogById: builder.query({
            query: (id) => {
                if (!id) return 'get';
                return `slug/${id}`;
            },
            // Disable caching
            keepUnusedDataFor: 0,
            // Force refetch on mount or args change
            refetchOnMountOrArgChange: true
        })
    })
});

export const { useGetBlogsQuery, useGetBlogByIdQuery } = blogApiService;